import { ACTION_TYPE, ModalAction } from '../../actions/modal'

export type State = {
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
}

export const initialState: State = {
  open: false,
  handleClose: () => {},
  handleSubmit: () => {},
}

export function reducer(state = initialState, action: ModalAction): State {
  switch (action.type) {
    case ACTION_TYPE.TOGGLE_MODAL_SUBMIT_FOR_REVIEW: {
      return {
        ...state,
        open: action.isOpen,
      }
    }
    case ACTION_TYPE.STORE_SUBMIT_CONFIRMATION_HANDLER: {
      return {
        ...state,
        handleClose: action.handleClose,
        handleSubmit: action.handleSubmit,
      }
    }
    default:
      return state
  }
}
